import React, { ReactElement } from 'react';
import { Box, CircularProgress } from '@mui/material';
import { THUMBNAIL_LOADING_OVERLAY_SX } from '../styles';

export const ThumbnailLoadingOverlay: React.FC = (): ReactElement => {
  return (
    <Box sx={THUMBNAIL_LOADING_OVERLAY_SX}>
      <CircularProgress size={40} />
    </Box>
  );
};
